(function () {
	'use strict';

	function init(tool) {
		if (!tool || tool.dataset.uykuInitialized === 'true') return;
		tool.dataset.uykuInitialized = 'true';

		var fallAsleepMin = parseInt(tool.dataset.fallAsleepMinutes, 10);
		if (isNaN(fallAsleepMin)) fallAsleepMin = 15;

		var cycleMin = parseInt(tool.dataset.cycleMinutes, 10);
		if (isNaN(cycleMin) || cycleMin <= 0) cycleMin = 90;

		var cyclesShown = parseInt(tool.dataset.cyclesShown, 10);
		if (isNaN(cyclesShown) || cyclesShown <= 0) cyclesShown = 6;

		var idealCycleMin = parseInt(tool.dataset.idealCycleMin, 10);
		if (isNaN(idealCycleMin)) idealCycleMin = 4;

		var modeButtons = tool.querySelectorAll('[data-uyku-mode]');
		var panels = tool.querySelectorAll('[data-uyku-panel]');
		var bedtimeAction = tool.querySelector('[data-uyku-action="bedtime"]');
		var waketimeAction = tool.querySelector('[data-uyku-action="waketime"]');
		var resetAction = tool.querySelector('[data-uyku-action="reset"]');
		var wakeInput = tool.querySelector('[data-uyku-input="bedtime"]');
		var resultsEl = tool.querySelector('[data-uyku-results]');
		var resultsTextEl = tool.querySelector('[data-uyku-results-text]');
		var timesListEl = tool.querySelector('[data-uyku-times]');

		function setMode(newMode) {
			for (var i = 0; i < modeButtons.length; i++) {
				var isActive = modeButtons[i].dataset.uykuMode === newMode;
				modeButtons[i].classList.toggle('is-active', isActive);
				modeButtons[i].setAttribute('aria-selected', isActive ? 'true' : 'false');
			}
			for (var j = 0; j < panels.length; j++) {
				var match = panels[j].dataset.uykuPanel === newMode;
				if (match) {
					panels[j].removeAttribute('hidden');
				} else {
					panels[j].setAttribute('hidden', '');
				}
			}
			hideResults();
		}

		function pad(n) {
			return n < 10 ? '0' + n : '' + n;
		}

		function formatTime(date) {
			return pad(date.getHours()) + ':' + pad(date.getMinutes());
		}

		function buildItem(date, cycles) {
			var totalMinutes = cycles * cycleMin;
			var hours = totalMinutes / 60;
			var hoursLabel = (hours % 1 === 0 ? hours.toFixed(0) : hours.toFixed(1)) + ' saat';
			var cyclesLabel = cycles + ' döngü';
			return {
				time: formatTime(date),
				cycles: cycles,
				ideal: cycles >= idealCycleMin,
				meta: cyclesLabel + ' · ' + hoursLabel
			};
		}

		function renderResults(text, items) {
			resultsTextEl.innerHTML = text;

			var html = '';
			for (var i = 0; i < items.length; i++) {
				var item = items[i];
				html +=
					'<li class="uyku-time' + (item.ideal ? ' is-ideal' : '') + '">' +
						'<span class="uyku-time__value">' + item.time + '</span>' +
						'<span class="uyku-time__meta">' + item.meta + '</span>' +
					'</li>';
			}
			timesListEl.innerHTML = html;
			resultsEl.removeAttribute('hidden');

			if (typeof resultsEl.scrollIntoView === 'function') {
				resultsEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
			}
		}

		function hideResults() {
			resultsEl.setAttribute('hidden', '');
			timesListEl.innerHTML = '';
			resultsTextEl.textContent = '';
		}

		function calcBedtime() {
			if (!wakeInput || !wakeInput.value) return;

			var parts = wakeInput.value.split(':');
			if (parts.length < 2) return;

			var h = parseInt(parts[0], 10);
			var m = parseInt(parts[1], 10);
			if (isNaN(h) || isNaN(m)) return;

			var wake = new Date();
			wake.setHours(h, m, 0, 0);
			var wakeFormatted = formatTime(wake);

			var items = [];
			for (var c = cyclesShown; c >= 1; c--) {
				var totalMin = c * cycleMin + fallAsleepMin;
				var bed = new Date(wake.getTime() - totalMin * 60000);
				items.push(buildItem(bed, c));
			}

			renderResults(
				'<strong>' + wakeFormatted + '</strong>’de uyanmak için, aşağıdaki saatlerden birinde yatağa girmelisiniz:',
				items
			);
		}

		function calcWaketime() {
			var start = new Date();
			start.setSeconds(0, 0);
			var nowFormatted = formatTime(start);

			start.setMinutes(start.getMinutes() + fallAsleepMin);

			var items = [];
			for (var c = 1; c <= cyclesShown; c++) {
				var wake = new Date(start.getTime() + c * cycleMin * 60000);
				items.push(buildItem(wake, c));
			}

			renderResults(
				'Şu an (<strong>' + nowFormatted + '</strong>) yatağa girerseniz, aşağıdaki saatlerden birinde uyanmalısınız:',
				items
			);
		}

		for (var i = 0; i < modeButtons.length; i++) {
			(function (btn) {
				btn.addEventListener('click', function () {
					setMode(btn.dataset.uykuMode);
				});
			})(modeButtons[i]);
		}

		if (bedtimeAction) bedtimeAction.addEventListener('click', calcBedtime);
		if (waketimeAction) waketimeAction.addEventListener('click', calcWaketime);
		if (resetAction) resetAction.addEventListener('click', hideResults);

		if (wakeInput) {
			wakeInput.addEventListener('keydown', function (e) {
				if (e.key === 'Enter') {
					e.preventDefault();
					calcBedtime();
				}
			});
		}
	}

	function bootstrap() {
		var tools = document.querySelectorAll('[data-uyku-tool]');
		for (var i = 0; i < tools.length; i++) init(tools[i]);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', bootstrap);
	} else {
		bootstrap();
	}

	if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
		document.addEventListener('shopify:section:load', function (event) {
			var tools = event.target.querySelectorAll('[data-uyku-tool]');
			for (var i = 0; i < tools.length; i++) init(tools[i]);
		});
	}
})();
